import { render, staticRenderFns } from "./exportData.vue?vue&type=template&id=2b953d7e&scoped=true"
import script from "./exportData.vue?vue&type=script&lang=js"
export * from "./exportData.vue?vue&type=script&lang=js"
import style0 from "./exportData.vue?vue&type=style&index=0&id=2b953d7e&prod&lang=scss"
import style1 from "./exportData.vue?vue&type=style&index=1&id=2b953d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b953d7e",
  null
  
)

export default component.exports